import { MAX_SAFE_SIGNIFICANT_DIGITS } from '../../../constants';
import { getSignificantDigitCount } from './getSignificantDigitCount';

export const hasTooManyDigits = (value: string) =>
  getSignificantDigitCount(value) > MAX_SAFE_SIGNIFICANT_DIGITS;
